import {useNavigate} from 'services/hooks'
import {useGetCurrentUserQuery, useI18n, useLogoutMutation} from 'store/Store'

const UseMainMenu = ({
    anchorEl,
    setAnchorEl,
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
}) => {
    const {i18n} = useI18n()
    const navigate = useNavigate()
    const [doLogout] = useLogoutMutation()
    const {data: user} = useGetCurrentUserQuery('UseMainMenu')
    const isMenuOpen = Boolean(anchorEl)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

    const goToLogin = () => navigate('/login')

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null)
    }
    const handleLogoutClick = async () => {
        await doLogout()
        handleMenuClose()
        navigate('/')
        window.location.reload()
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
        handleMobileMenuClose()
    }

    const handleProfile = (e) => {
        handleMenuClose()
        navigate('/profile')
    }
    const t = (label) => i18n.t(`main.${label}`)

    return {
        goToLogin,
        isMenuOpen,
        isMobileMenuOpen,
        handleProfile,
        handleMenuClose,
        handleMobileMenuClose,
        handleLogoutClick,
        t,
        user,
    }
}

export default UseMainMenu
